export function fn () {
  console.log('lib1 fn');
}

export function treeshaked () {
  console.log('this is tree shaken!');
}